import { render, staticRenderFns } from "./StudentsEdit.vue?vue&type=template&id=bbb74d06&scoped=true"
import script from "./StudentsEdit.vue?vue&type=script&lang=js"
export * from "./StudentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb74d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbb74d06')) {
      api.createRecord('bbb74d06', component.options)
    } else {
      api.reload('bbb74d06', component.options)
    }
    module.hot.accept("./StudentsEdit.vue?vue&type=template&id=bbb74d06&scoped=true", function () {
      api.rerender('bbb74d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolManage/students/StudentsEdit.vue"
export default component.exports